module.exports = __webpack_public_path__ + "img/Dollar Icon - white.0140148e.svg";